<template>
  <section class="evento-lux">

    <!-- ===== TARJETA ÚNICA: RECEPCIÓN ===== -->
    <article ref="card2" class="card" aria-label="Recepción">
      <img class="icono" src="@/assets/10.avif" alt="Ícono recepción" />
      <h3 class="titulo-script">Celebración</h3>
      <p class="hora">4:00 pm</p>
      <p class="lugar">Club Naval</p>
      <p class="direccion">
        Av. José Azueta s/n, Playa el Borrego<br>
        San Blas, Nayarit.
      </p>

      <a
        ref="btn2"
        class="btn-rosa"
        href="https://maps.app.goo.gl/KkVx5zbJKyhsvD1d8"
        target="_blank"
        rel="noopener"
      >
        ¿Cómo llegar?
        <span class="sheen"></span>
      </a>
    </article>

  </section>
</template>

<script>
import { ref, onMounted } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'EventoSectionLuxuryScroll',
  setup() {

    const card2 = ref(null)
    const btn2 = ref(null)

    const animCard = (cardEl, btnEl) => {

      const $ = gsap.utils.selector(cardEl)
      const icono  = $('.icono')
      const titulo = $('.titulo-script')
      const hora   = $('.hora')
      const lugar  = $('.lugar')
      const dir    = $('.direccion')

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: cardEl,
          start: 'top 85%',
          toggleActions: 'play none none none'
        },
        defaults: { ease: 'power2.out' }
      })

      tl.from(cardEl, { opacity: 0, y: 40, duration: 0.6 })
        .from(icono,  { opacity: 0, y: 20, duration: 0.5 }, '-=0.3')
        .from(titulo, { opacity: 0, y: 20, duration: 0.5 }, '-=0.3')
        .from(hora,   { opacity: 0, x: -20, duration: 0.4 }, '-=0.3')
        .from(lugar,  { opacity: 0, x: 20, duration: 0.4 }, '-=0.4')
        .from(dir,    { opacity: 0, y: 20, duration: 0.4 }, '-=0.3')
        .from(btnEl,  { opacity: 0, scale: 0.95, duration: 0.4 }, '-=0.3')

      // Brillo del botón
      ScrollTrigger.create({
        trigger: cardEl,
        start: 'top 85%',
        once: true,
        onEnter: () => {
          const shine = btnEl.querySelector('.sheen')
          if (!shine) return
          gsap.fromTo(
            shine,
            { xPercent: -120, opacity: 0 },
            { xPercent: 140, opacity: 1, duration: 0.8, ease: 'power2.out' }
          )
        }
      })
    }

    onMounted(() => {
      animCard(card2.value, btn2.value)
    })

    return { card2, btn2 }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@600;700&family=Great+Vibes&family=Playfair+Display:ital,wght@0,500;0,600;1,400&family=Poppins:wght@400;500;600;700&display=swap');

/* ==================== BASE ELEGANTE ==================== */
.evento-lux {
  background-color: #f5f0e6;
  /* Efecto papel fino de invitación */

  color: #4979a0;
  min-height: 55vh;
  padding: 34px 20px 40px;
  margin-top: -60px;
  margin-bottom: 5px;
  box-sizing: border-box;
  position: relative;
  display: grid;
  gap: 22px;
  place-items: center;
}

/* ==================== TARJETA ==================== */
.card {
  width: min(440px, 92vw);
  border: 1.5px solid #cba56b;
  border-radius: 20px;
  background-color: #f5f0e6;
    margin-top:-20px;
margin-bottom: -80px;
  padding: 30px 20px 32px;  
  margin-bottom: -25px;
  text-align: center;
  box-sizing: border-box;
}

/* Ícono discreto en dorado */
.icono {
  width: 48px;
  height: auto;
  display: block;
  margin: 0 auto 12px;
  opacity: 0.9;
  filter: brightness(0) saturate(100%) invert(69%) sepia(26%) saturate(693%) hue-rotate(1deg) brightness(93%) contrast(88%);
}

/* TÍTULO EN AZUL CELESTE EDITORIAL */
.titulo-script {
  font-family: 'Cinzel', 'Playfair Display', serif;
  font-weight: 700;
  font-size: 28px;
  letter-spacing: 2px;
  margin: 4px 0 10px;
  color: #4979a0;
  text-transform: uppercase;
}

.hora {
  font-family: 'Great Vibes', cursive, serif;
  font-size: 32px;
  color: #cba56b;
  margin: 0 0 6px;
  font-weight: 500;
}

.lugar {
  font-family: 'Playfair Display', serif;
  font-size: 20px;
  color: #4979a0;
  font-weight: 600;
  margin: 0 0 10px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.direccion {
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  color: #4979a0;
  line-height: 1.6;
  margin: 0 auto 20px;
  max-width: 90%;
}

/* ==================== BOTÓN LAGO CELESTE / DORADO ==================== */
.btn-rosa {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  padding: 13px 28px;
  border-radius: 25px;

  background: linear-gradient(135deg, #ffffff 0%, #f0f7fc 100%);
  color: #4979a0;

  text-decoration: none;

  font-family: 'Playfair Display', serif;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: 2px;
  text-transform: uppercase;
  line-height: 1;

  border: 1.5px solid #cba56b;

  box-shadow:
    0 4px 12px rgba(73, 121, 160, 0.15),
    inset 0 1px 0 rgba(255, 255, 255, 0.8);

  overflow: hidden;
  z-index: 0;
  cursor: pointer;

  transition:
    transform .35s ease,
    box-shadow .35s ease,
    background .35s ease;
}

/* HOVER */
.btn-rosa:hover {
  transform: translateY(-2px) scale(1.02);
  background: #ffffff;
  box-shadow:
    0 6px 18px rgba(73, 121, 160, 0.25),
    0 0 12px rgba(203, 165, 107, 0.3);
}

/* BRILLO DORADO */
.btn-rosa::before {
  content: "";
  position: absolute;
  top: 0;
  left: -120%;
  width: 70%;
  height: 100%;

  background: linear-gradient(
    120deg,
    transparent,
    rgba(203, 165, 107, 0.25),
    transparent
  );

  transform: skewX(-22deg);
  animation: brilloDorado 3.5s infinite;
  z-index: 1;
}

@keyframes brilloDorado {
  0% { left: -120%; }
  100% { left: 180%; }
}

/* TEXTO ENCIMA */
.btn-rosa span,
.btn-rosa {
  position: relative;
  z-index: 2;
}

/* ==================== RESPONSIVE ==================== */
@media (max-width: 380px) {
  .titulo-script { font-size: 24px; }
  .hora { font-size: 28px; }
  .lugar { font-size: 18px; }
}

/* Accesibilidad */
@media (prefers-reduced-motion: reduce) {
  * { transition: none !important; animation: none !important; }
}
</style>